import { toast } from "react-toastify"
import React, { useState } from "react"

import { BespokePanel } from "../../lib/fragments/BespokePanel"
import { G_onInputBlurHandler, G_onInputChangeHandler } from "../../components/utils/InputHandlers"
import { InputBasic } from "../../components/utils/InputBasic"
import { InputTextArea } from "../../components/utils/InputTextArea"
import { ASSETS } from "../../api/Registry"
import HttpServices from "../../services/HttpServices"
import { APPLICATION } from "../../utils/Constants"

export const CreateCategory = ({ show, showOrHide, onComplete }) => {
    const [state, setstate] = useState({
        posting: false,
        httpStatus: 200,
        status: 'fulfilled',
        input: {
            name: '',
            description: '',
        },
        errors: {
            name: '',
            description: '',
        }
    })

    const onChangeHandler = (e: any) => {
        let { posting } = state

        if (!posting) {
            let { input } = state
            let { errors } = state
            let output: any = G_onInputChangeHandler(e)

            const updatedInput = {
                ...input,
                [e.target.name]: output.value
            };

            const updatedErrors = {
                ...errors,
                [e.target.name]: output.error
            };

            setstate((prev) => ({
                ...prev,
                input: updatedInput,
                errors: updatedErrors,
            }));
        }
    }

    const onInputBlur = (e: any) => {
        let { posting } = state

        if (!posting) {
            let { input } = state
            let { errors } = state
            let output: any = G_onInputBlurHandler(e, '')

            const updatedInput = {
                ...input,
                [e.target.name]: output.value
            };

            const updatedErrors = {
                ...errors,
                [e.target.name]: output.error
            };

            setstate((prev) => ({
                ...prev,
                input: updatedInput,
                errors: updatedErrors,
            }));
        }
    }

    const onFormSubmitHandler = (e: any) => {
        e.preventDefault()
        let { posting } = state

        if (!posting) {
            let validity = true
            let { input } = state

            const inputArray = Object.keys(input)

            inputArray.forEach((inputObject: any) => {
                let oTarget = e.target[inputObject]

                const event = {
                    target: {
                        name: oTarget.name,
                        required: oTarget.required,
                        value: oTarget.value.trim(),
                    }
                }

                onInputBlur(event)
            })

            let { errors } = state
            const errorArray = Object.keys(errors)

            errorArray.forEach((errorObject) => {
                if (errors[errorObject].length > 0) {
                    validity = false
                }
            })

            if (validity) {
                setstate((prev) => ({
                    ...prev,
                    posting: !prev.posting
                }))

                createCategory()
            }
        }
    }

    const createCategory = async () => {
        let { input } = state
        let { errors } = state
        let { httpStatus } = state

        try {
            let formData = new FormData()
            formData.append('name', input.name)
            formData.append('description', input.description)

            const response: any = await HttpServices.httpPost(ASSETS.ALL_CATEGORIES, formData)
            httpStatus = response.status

            if (httpStatus === 200) {
                const payload: any = response.data.payload

                const updatedInput = {
                    ...input,
                    name: '',
                    description: '',
                };

                setstate((prev) => ({
                    ...prev,
                    input: updatedInput,
                }));

                let actionCompleted = {
                    name: input.name,
                    uuid: payload.uuid,
                    description: input.description,
                }

                onComplete(actionCompleted)
            } else {
                if (response.status === 422) {
                    Object.entries(response.data).forEach(([field, errorMessages]) => {
                        const submissionErrors = {
                            ...errors,
                            [field]: errorMessages
                        };

                        setstate((prev) => ({
                            ...prev,
                            errors: submissionErrors,
                        }));
                    });
                } else {
                    toast.error(APPLICATION.ERR_MSG, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            }
        } catch (error) {
            httpStatus = 500
        }

        setstate((prevState) => ({
            ...prevState, httpStatus, posting: !prevState.posting
        }));
    }

    return (
        <React.Fragment>
            <BespokePanel
                show={show}
                status={state.status}
                title={"Add Category"}
                showOrHide={showOrHide}
                description={"Group assets into broad categories like hardware or software for easier management"}
                components={
                    <form className="w-full flex-grow flex flex-col" onSubmit={onFormSubmitHandler}>
                        <div className="w-full flex-grow px-6 py-4">
                            <div className="mb-3">
                                <InputBasic
                                    name={"name"}
                                    required={true}
                                    label={"Category Name"}
                                    posting={state.posting}
                                    value={state.input.name}
                                    error={state.errors.name}
                                    blurHandler={onInputBlur}
                                    changeHandler={onChangeHandler}
                                />
                            </div>

                            <div className="mb-3">
                                <InputTextArea
                                    name={"description"}
                                    required={true}
                                    label={"Description"}
                                    posting={state.posting}
                                    value={state.input.description}
                                    error={state.errors.description}
                                    blurHandler={onInputBlur}
                                    changeHandler={onChangeHandler}
                                />
                            </div>
                        </div>

                        <div className="flex-none border-t py-4 px-5 w-full sm:flex sm:flex-row">
                            <div className="w-full space-y-px">
                                <div className="flex flex-row- items-center align-middle gap-x-4">
                                    <button type="submit" className="w-auto min-w-24 disabled:cursor-not-allowed text-sm rounded-md border border-transparent shadow-sm px-3 py-1.5 bg-primary text-white disabled:bg-primary hover:bg-secondary focus:outline-none" disabled={state.posting}>
                                        {
                                            state.posting ? (
                                                <span className="flex flex-row items-center align-middle h-5 justify-center">
                                                    <i className="fad fa-spinner-third fa-xl fa-spin"></i>
                                                </span>
                                            ) : (
                                                <span>Create</span>
                                            )
                                        }
                                    </button>

                                    <button type="button" onClick={showOrHide} className="text-sm flex-none shadow-none px-3 py-1 bg-inherit text-slate-600 hover:underline hover:cursor-pointer mr-2 sm:w-auto sm:text-sm">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                }
            />
        </React.Fragment>
    )
}